export const cn = <T>(...args: T[]) => {
    return args.filter(Boolean).join(" ");
};
